<div class="overflow-y-auto height-100" #pageContent (scroll)="onScrollEvent()">
    <dp-connect-matter-info #matterInfo></dp-connect-matter-info>
    <mat-toolbar *ngIf="matterInfo.matterInfo?.projectSharingInformation && matterInfo?.sharedDocumentsPackage?.isUserOtherPartyProjectLawyerOrLawClerk()">

            <mat-toolbar-row>
                <span>Project Information</span>
            </mat-toolbar-row>
    </mat-toolbar>

        <div *ngIf="matterInfo.matterInfo?.projectSharingInformation &&
       matterInfo?.sharedDocumentsPackage?.isUserOtherPartyProjectLawyerOrLawClerk()" class="padding-10 font-20">
                <textarea rows="5" readonly class="col-md-12 mat-card-subtitle dp-textarea">{{matterInfo.matterInfo?.projectSharingInformation}}</textarea>
        </div>

    <mat-toolbar>
        <mat-toolbar-row>
            <span>Shared Document(s)</span>
        </mat-toolbar-row>
    </mat-toolbar>
    <div *ngIf="sharedDocumentsPackage?.isSharingRevoked()" class="bold">
        Shared Documents are no longer available
    </div>
    <div *ngIf="sharedDocumentsPackage?.isSharingPartiallyRevoked()">
        A shared document is no longer available. Please see notification from the sender for details.
    </div>
    <div *ngIf="documentList && documentList.length == 0" class="padding-10 font-20">
        No Documents available
    </div>
    <div *ngIf="message" class="padding-20">
        {{message}}
    </div>

    <div>

        <table mat-table dp-table-commands
               [dataSource]="documentList" multiTemplateDataRows
               class="mat-elevation-z8">

            <ng-container matColumnDef="expanded">
                <th mat-header-cell *matHeaderCellDef ></th>
                <td mat-cell  *matCellDef="let element" (click)="setExpandedElement(element ,$event)">
                    <div *ngIf="element == expandedElement" class="padding-left-5">
                        <img src="assets/img/shutter-minus.png" alt="close"/>
                    </div>
                    <div *ngIf="element != expandedElement" class="padding-left-5">
                        <img src="assets/img/shutter-plus.png" alt="open"/>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef><div class="text-left" style="width: 40%">File Name</div></th>
                <td mat-cell *matCellDef="let element" class="text-left padding-left-15" style="width: 40%">
                    <div class="padding-left-15"><a>{{element.name}}</a></div>
                </td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell class="red bold text-left"
                    *matCellDef="let element">
                    {{element.docStatus}}
                </td>
            </ng-container>

            <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef><div class="text-left" style="width: 40%">Description</div></th>
                <td mat-cell class="text-left" style="width: 40%"
                    *matCellDef="let element">
                    {{element.description}}
                </td>
            </ng-container>

            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef><div class="text-left">Date</div></th>
                <td mat-cell *matCellDef="let element" class="text-left">
                    {{element.date | date : 'mediumDate'}}
                </td>
            </ng-container>

            <ng-container matColumnDef="expandedDetail">
                <td mat-cell *matCellDef="let element" colspan="4">
                    <div class="expandable-element-detail"
                         [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                        <div class="row expanded-element-detail">
                            <div><span class="bold">Status:</span> {{element.docStatus}}</div>
                            <div *ngIf="element.description"><span class="bold">Description:</span> {{element.description}}</div>


                        </div>
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columnsToDisplay"  ></tr>
            <tr tabindex="0" mat-row *matRowDef="let element; columns: columnsToDisplay;" (click)="openFile(element.id)" (keydown.enter)="openFile(element.id)"
                class="expandable-element-row"
                [class.expandable-expanded-row]="expandedElement === element"
            >
            </tr>
            <tr tabindex="0" mat-row *matRowDef="let row; columns: ['expandedDetail']" class="expandable-detail-row" (click)="openFile(row.id)" (keydown.enter)="openFile(row.id)"></tr>
        </table>
    </div>

    <div class="back-to-top-block d-12 d-lg-none ">
        <button id="backToTopBtn" title="Go to top" #backToTopBtn (click)="backToTop()"><i class="fa fa-arrow-up"></i>
        </button>
    </div>
</div>


